import { useEffect, useState } from 'react';

import { useGlobalState } from '../GlobalState';

const useWeatherValue = () => {
	const { REACT_APP_API_KEY } = process.env;
	const [locations, setLocations] = useState(JSON.parse(localStorage.getItem('locations')) || []);
	const dispatch = [...useGlobalState()].pop(); // I don't need to access any of the reducer state

	const addLocation = (location) => {
		const index = locations.findIndex((item) => item.id === location.id);
		const newLocations = [...locations];

		if (index === -1) {
			newLocations.push(location);
		} else {
			newLocations[index] = location;
		}

		setLocations(newLocations);
	};

	const removeLocation = (location) => {
		const index = locations.findIndex((item) => item.id === parseInt(location.id, 10));
		const newLocations = [...locations];

		newLocations.splice(index, 1);

		// TODO: change page
		// if (activeLocation === locations.length && activeLocation !== 0) {
		// 	this.updateActiveLocation(activeLocation - 1);
		// }
		setLocations(newLocations);
	};

	const getWeather = async ({
		city = null,
		country = null,
		// id = null,
	}) => {
		// TODO: use city ID to get the forecast if it exists
		// "We recommend to call API by city ID to get unambiguous result for your city."
		if (city) {
			dispatch({ type: 'app-loading', value: true });

			// eslint-disable-next-line no-undef
			await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}${country && `,${country}`}&appid=${REACT_APP_API_KEY}&units=metric`)
				.then((response) => response.json())
				.then((data) => {
					console.log(data); // eslint-disable-line no-console

					if (!data.message) {
						const weather = {
							city: data.name,
							country: data.sys.country,
							date: data.dt,
							description: data.weather[0].description,
							id: data.id,
							icon: data.weather[0].icon,
							lastUpdate: Math.floor(Date.now() / 1000),
							sunrise: data.sys.sunrise,
							sunset: data.sys.sunset,
							temperature: Math.round(data.main.temp),
							temperatureMax: Math.round(data.main.temp),
							temperatureMin: Math.round(data.main.temp_min),
						};

						addLocation(weather);

						dispatch({ type: 'app-loading', value: false });
						// TODO: update page
						// if (index === -1) this.updateActiveLocation(locations.length - 1);
					} else {
						dispatch({ type: 'app-loading', value: false });
						dispatch({ type: 'app-error', value: data });
					}
				});
		} else {
			dispatch({ type: 'app-error', value: 'Please enter a location' });
		}
	};

	useEffect(() => {
		localStorage.setItem('locations', JSON.stringify(locations));
	}, [locations]); // eslint-disable-line

	return {
		addLocation,
		getWeather,
		locations,
		removeLocation,
		setLocations,
	};
};

export default useWeatherValue;
